import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, EntityLookup, MicroMClient, MicromUsersStatusPanelLookups, MicromUserStatusPanelColumns, ValuesObject } from "@mcurros2/microm";
import { DomiciliosColumns, DomiciliosLookups } from "Components/Domicilios/DomiciliosColumns";
import { Bancos } from "../Bancos/Bancos";
import { catAreasPersonal } from "../Categorias y Estados/catAreasPersonal";
import { catGenero } from "../Categorias y Estados/catGenero";
import { catMotivosBaja } from "../Categorias y Estados/catMotivosBaja";
import { catTiposDocumento } from "../Categorias y Estados/catTiposDocumento";
import { Personas } from "../Personas/Personas";
import { PlantillasHorarios } from "../PlantillasHorarios/PlantillasHorarios";
import { PuestosTrabajo } from "../PuestosTrabajo/PuestosTrabajo";
import { ACTAgregarPersonal } from "./ACTAgregarPersonal";
import { ACTAsignarSuperior } from "./ACTAsignarSuperior";
import { ACTEliminarPersonal } from "./ACTEliminarPersonal";
import { ACTGestionarPersonal } from "./ACTGestionarPersonal";
import { ACTReasignarPersonal } from "./ACTReasignarPersonal";
import { ACTReemplazarPersonal } from "./ACTReemplazarPersonal";
import { GestionPersonalDetallesViewInfoWindowRenderer } from "./GestionPersonalDetallesViewInfoWindowRenderer";
import { GestionPersonalDetallesViewMarkerRenderer } from "./GestionPersonalDetallesViewMarkerRenderer";
import { Personal } from "./Personal";
import { PersonalAsignarFilters } from "./PersonalAsignarFilters/PersonalAsignarFilters";
import { PersonalFilters } from "./PersonalFilters/PersonalFilters";
import { PersonalGestionFilters } from "./PersonalGestionFilters/PersonalGestionFilters";


const columns = () =>
(
    {
        c_personal_id: new EntityColumn<string>({ name: 'c_personal_id', type: 'char', length: 20, flags: c.PKAutonum, prompt: 'Personal Id' }),
        c_personalguid_id: new EntityColumn<string>({ name: 'c_personalguid_id', type: 'char', length: 36, flags: c.FK, prompt: 'Personalguid Id' }),
        c_persona_id: new EntityColumn<string>({ name: 'c_persona_id', type: 'char', length: 20, flags: c.FK, prompt: 'Persona Id' }),
        c_puestotrabajo_id: new EntityColumn<string>({ name: 'c_puestotrabajo_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Puesto Trabajo' }),
        c_personallegajo_id: new EntityColumn<string>({ name: 'c_personallegajo_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Legajo RRHH' }),
        dt_fecha_alta: new EntityColumn<Date>({ name: 'dt_fecha_alta', type: 'datetime', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Fecha Alta' }),
        vc_numerodni: new EntityColumn<string>({ name: 'vc_numerodni', type: 'varchar', length: 255, flags: c.Edit, prompt: 'DNI' }),
        vc_numerocuil: new EntityColumn<string>({ name: 'vc_numerocuil', type: 'varchar', length: 255, flags: c.Edit, prompt: 'CUIL' }),
        c_areapersonal_id: new EntityColumn<string>({ name: 'c_areapersonal_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Area' }),
        c_banco_id: new EntityColumn<string>({ name: 'c_banco_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Banco' }),
        vc_nombre: new EntityColumn<string>({ name: 'vc_nombre', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Nombre' }),
        vc_apellido: new EntityColumn<string>({ name: 'vc_apellido', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Apellido' }),
        dt_nacimiento: new EntityColumn<Date>({ name: 'dt_nacimiento', type: 'date', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Nacimiento' }),
        c_fotofileprocess_id: new EntityColumn<string>({ name: 'c_fotofileprocess_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Fotofileprocess Id' }),
        c_genero_id: new EntityColumn<string>({ name: 'c_genero_id', type: 'char', length: 20, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Género' }),
        c_dnifileprocess_id: new EntityColumn<string>({ name: 'c_dnifileprocess_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Dnifileprocess Id' }),
        c_cuilfileprocess_id: new EntityColumn<string>({ name: 'c_cuilfileprocess_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Cuilfileprocess Id' }),
        vc_fotoguid: new EntityColumn<string>({ name: 'vc_fotoguid', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Fotoguid' }),
        c_plantillahorario_id: new EntityColumn<string>({ name: 'c_plantillahorario_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Plantilla Horario' }),
        vc_telefono: new EntityColumn<string>({ name: 'vc_telefono', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Teléfono' }),
        vc_celular: new EntityColumn<string>({ name: 'vc_celular', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Celular' }),
        vc_celular_trabajo: new EntityColumn<string>({ name: 'vc_celular_trabajo', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Celular Trabajo' }),
        vc_telefono_alternativo: new EntityColumn<string>({ name: 'vc_telefono_alternativo', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Teléfono Alternativo' }),
        vc_email: new EntityColumn<string>({ name: 'vc_email', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Email' }),
        vc_email_alternativo: new EntityColumn<string>({ name: 'vc_email_alternativo', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Email Alternativo' }),
        c_superior_id: new EntityColumn<string>({ name: 'c_superior_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Superior' }),

        ...DomiciliosColumns(false),

        dt_fecha_baja: new EntityColumn<Date>({ name: 'dt_fecha_baja', type: 'datetime', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Fecha Baja' }),
        c_motivobaja_id: new EntityColumn<string>({ name: 'c_motivobaja_id', type: 'char', length: 20, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Motivo' }),
        vc_observaciones_baja: new EntityColumn<string>({ name: 'vc_observaciones_baja', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Observaciones' }),

        ...MicromUserStatusPanelColumns(),

        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        perl_brwStandard: { name: 'perl_brwStandard', keyMappings: { c_personal_id: 0 } },
        perl_brwCard: {
            name: 'perl_brwCard', keyMappings: { c_personal_id: 0 },
            FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new PersonalFilters(client, parentKeys),
        },
        perl_brwGetPorDNI: { name: 'perl_brwGetPorDNI', keyMappings: { c_personal_id: 0, c_persona_id: 1 } },
        perl_brwAsignadoATiendas: { name: 'perl_brwAsignadoATiendas', keyMappings: { c_personal_id: 0 } },
        perl_brwJefes: { name: 'perl_brwJefes', keyMappings: { c_personal_id: 0 } },
        perl_brwEnRutas: { name: 'perl_brwEnRutas', keyMappings: { c_personal_id: 0 } },
        perl_brwGestionPersonal: {
            name: 'perl_brwGestionPersonal', keyMappings: { c_personal_id: 0, vc_nombre: 1 },
            FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new PersonalGestionFilters(client, parentKeys),
        },
        perl_brwGestionPersonalDetalles: {
            name: 'perl_brwGestionPersonalDetalles', keyMappings: { c_personal_id: 0 },
            FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new PersonalAsignarFilters(client, parentKeys),
            mapMarkerRenderer: GestionPersonalDetallesViewMarkerRenderer,
            mapInfoWindowRenderer: GestionPersonalDetallesViewInfoWindowRenderer
        },
        perl_brwGestionPersonalDetallesAgregar: {
            name: 'perl_brwGestionPersonalDetallesAgregar', keyMappings: { c_personal_id: 0 },
            FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new PersonalAsignarFilters(client, parentKeys),
        },
        perl_brwGestionPersonalDetallesReasignar: {
            name: 'perl_brwGestionPersonalDetallesReasignar', keyMappings: { c_personal_id: 0 },
            FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new PersonalAsignarFilters(client, parentKeys),
        },
    }
)

const lookups = () =>
(
    {
        'Personas': {
            name: 'Personas',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Personas(client, parentKeys)
        },

        'PuestosTrabajo': {
            name: 'PuestosTrabajo',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new PuestosTrabajo(client, parentKeys)
        },

        'TiposDocumento': {
            name: 'TiposDocumento',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catTiposDocumento(client, parentKeys)
        },

        'AreasPersonal': {
            name: 'AreasPersonal',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catAreasPersonal(client, parentKeys)
        },

        'Genero': {
            name: 'Genero',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catGenero(client, parentKeys)
        },
        'PlantillasHorarios': {
            name: 'PlantillasHorarios',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new PlantillasHorarios(client, parentKeys)
        },
        'Superior': {
            name: 'Superior',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            bindingColumnKey: 'c_personal_id',
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Personal(client, parentKeys)
        } as EntityLookup,
        'MotivosBaja': {
            name: 'MotivosBaja',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catMotivosBaja(client, parentKeys)
        },
        'Bancos': {
            name: 'Bancos',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Bancos(client, parentKeys)
        },

        ...DomiciliosLookups(),

        ...MicromUsersStatusPanelLookups()
    }
)

const procs = () =>
(
    {
        perl_AsignarSuperior: { name: 'perl_AsignarSuperior' },
        perl_ReemplazarPersonal: { name: 'perl_ReemplazarPersonal' }
    }
)

const clientActions = () =>
(
    {
        ACTAsignarSuperior: ACTAsignarSuperior,
        ACTReemplazarPersonal: ACTReemplazarPersonal,
        ACTGestionarPersonal: ACTGestionarPersonal,
        ACTAgregarPersonal: ACTAgregarPersonal,
        ACTEliminarPersonal: ACTEliminarPersonal,
        ACTReasignarPersonal: ACTReasignarPersonal
    }
)

export class PersonalDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();
    procs = procs();
    clientActions = clientActions();

    constructor() {
        super('Personal');
    }
}